import { HStack, Icon, RadioCard } from '@chakra-ui/react';
import { MentionBoostDestinationType } from '@fluenceur/types';
import { Bag, Globe } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

interface DestinationSelectorProps {
  isShopifyConnected: boolean;
  onChange: (type: MentionBoostDestinationType) => void;
  value: MentionBoostDestinationType;
}

export function DestinationSelector({
  isShopifyConnected,
  onChange,
  value,
}: DestinationSelectorProps) {
  const { t } = useTranslation();

  const productPageDisabled = !isShopifyConnected;
  const disabledReason = t('mentions.boost.setup.destination.productPageDisabledReason');

  return (
    <RadioCard.Root
      colorPalette="primary"
      value={value}
      onValueChange={(details) => {
        if (details.value) {
          onChange(details.value as MentionBoostDestinationType);
        }
      }}
    >
      <HStack align="stretch" gap={2} w="full">
        <RadioCard.Item
          flex="1"
          rounded="lg"
          value={MentionBoostDestinationType.PRODUCT_PAGE}
          disabled={productPageDisabled}
          title={productPageDisabled ? disabledReason : undefined}
        >
          <RadioCard.ItemHiddenInput />
          <RadioCard.ItemControl>
            <RadioCard.ItemContent>
              <Icon size="md" color="fg.muted" mb="1.5">
                <Bag />
              </Icon>
              <RadioCard.ItemText>
                {t('mentions.boost.setup.destination.productPageLabel')}
              </RadioCard.ItemText>
              <RadioCard.ItemDescription>
                {productPageDisabled
                  ? disabledReason
                  : t('mentions.boost.setup.destination.productPageDescription')}
              </RadioCard.ItemDescription>
            </RadioCard.ItemContent>
          </RadioCard.ItemControl>
        </RadioCard.Item>

        <RadioCard.Item flex="1" rounded="lg" value={MentionBoostDestinationType.WEBSITE}>
          <RadioCard.ItemHiddenInput />
          <RadioCard.ItemControl>
            <RadioCard.ItemContent>
              <Icon size="md" color="fg.muted" mb="1.5">
                <Globe />
              </Icon>
              <RadioCard.ItemText>
                {t('mentions.boost.setup.destination.websiteLabel')}
              </RadioCard.ItemText>
              <RadioCard.ItemDescription>
                {t('mentions.boost.setup.destination.websiteDescription')}
              </RadioCard.ItemDescription>
            </RadioCard.ItemContent>
          </RadioCard.ItemControl>
        </RadioCard.Item>
      </HStack>
    </RadioCard.Root>
  );
}
